import React, { useEffect, useRef } from 'react';
//import Tab from '../Tab';
import ReportByPeriod from './ReportByPeriod';
import { ReactComponent as IconQuestion } from './../Tutorial/question-icon.svg';
import styles from './styles.module.scss';
import { reportPaymentTutorialSteps } from './tutorial/steps';
import { useTutorial } from '../Tutorial/useTutorial';
import { useGetMerchants } from '../../Utils/useGetMerchants';
import AnalyticsEvent, {
  AnalyticsList,
} from '../../services/analytics/AnalyticsEvent';
import { TUTORIAL_KEYS } from '../../Utils/constants';
import '../Tutorial/tutorial.scss';

const MerchantReportPayments = () => {
  const isTracked = useRef(false);
  const merchants = useGetMerchants();
  const { tourInstance, initTutorial } = useTutorial({
    ...TUTORIAL_KEYS.merchantPaymentReport,
    steps: shepherd =>
      reportPaymentTutorialSteps(shepherd, merchants.length > 1),
  });

  const handleStartTutorial = () => {
    tourInstance.start();
  };

  useEffect(() => {
    if (!isTracked.current) {
      AnalyticsEvent().pageView({
        page: AnalyticsList.merchantPayments,
      });
      AnalyticsEvent().paymentReportViewed();
      isTracked.current = true;
    }

    initTutorial();
  }, []);

  return (
    <div className={styles.containerView}>
      <div className={styles.header}>
        <div className={styles.titlePage}>
          Reporte de pagos a comercio
          <IconQuestion
            id='activate-tutorial'
            className={`activate-tutorial ${styles.iconQuestionMark}`}
            onClick={handleStartTutorial}
          />
        </div>
        <div className={styles.helper}>
          Detalle de pagos de Kueski a tu comercio.
        </div>
      </div>
      <ReportByPeriod />
    </div>
  );
};

export default MerchantReportPayments;
